import { Card, Flex } from "@mantine/core";
import { client_selected } from "../../../../client";

interface IProps {
  children: React.ReactNode;
  onClick: () => void;
  image?: string;
  title?: string;
}

export default function ComponentNewCard({
  onClick,
  children,
  image,
  title,
}: IProps) {
  return (
    <Card
      onClick={onClick}
      withBorder
      p={12}
      miw={"100%"}
      mih={322}
      sx={(theme) => ({
        textDecoration: "none",
        cursor: "pointer",
        transition: "all 0.5s ease-in-out",
        borderRadius: "12px",
        boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.05)",
        overflow: "hidden",
        background: theme.colors.other[3],
      })}
    >
      <Flex h="100%" w="100%" style={{ position: "relative", zIndex: 1 }}>
        <Flex
          h="100%"
          w="100%"
          justify="center"
          align="center"
          style={{
            zIndex: 0,
            position: "absolute",
            overflow: "hidden",
            borderRadius: "10px",
          }}
        >
          <img
            src={!!image ? image : client_selected.image.logo2}
            alt={title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: !!image ? "cover" : "fill",
              zIndex: 0,
              filter: "brightness(0.8)",
            }}
          />
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              zIndex: 1,
              background:
                "linear-gradient(180.2deg, rgba(0, 0, 0, 0) 0%, rgba(14, 16, 28, 0.52) 35%, #191C33 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))",
            }}
          />
        </Flex>
        <Flex
          direction={"column"}
          h="100%"
          justify="space-between"
          w="100%"
          style={{ position: "relative", zIndex: 1 }}
          gap={"10px"}
        >
          {children}
        </Flex>
      </Flex>
    </Card>
  );
}
